var _rect, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 4.5,
    fill: "#F2F6FF",
    stroke: "#2D4BF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3204_18300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.061 25.4613C27.5253 24.9837 27.0563 24.4362 26.6666 23.8335C26.2411 23.0016 25.9861 22.0931 25.9166 21.1613V18.4169C25.9202 16.9533 25.3893 15.5388 24.4236 14.4391C23.4579 13.3394 22.1239 12.6301 20.6721 12.4447V11.728C20.6721 11.5313 20.594 11.3426 20.4549 11.2036C20.3158 11.0645 20.1271 10.9863 19.9304 10.9863C19.7337 10.9863 19.5451 11.0645 19.406 11.2036C19.2669 11.3426 19.1888 11.5313 19.1888 11.728V12.4558C17.75 12.6546 16.4321 13.3681 15.4791 14.4642C14.5261 15.5602 14.0025 16.9645 14.0054 18.4169V21.1613C13.9359 22.0931 13.6809 23.0016 13.2554 23.8335C12.8726 24.4349 12.4111 24.9823 11.8832 25.4613C11.824 25.5134 11.7765 25.5775 11.7439 25.6493C11.7113 25.7212 11.6944 25.7991 11.6943 25.878V26.6335C11.6943 26.7809 11.7529 26.9222 11.8571 27.0264C11.9612 27.1306 12.1025 27.1891 12.2499 27.1891H27.6943C27.8417 27.1891 27.983 27.1306 28.0872 27.0264C28.1914 26.9222 28.2499 26.7809 28.2499 26.6335V25.878C28.2498 25.7991 28.2329 25.7212 28.2003 25.6493C28.1678 25.5775 28.1203 25.5134 28.061 25.4613ZM12.8499 26.078C13.3668 25.5787 13.8219 25.0191 14.2054 24.4113C14.7413 23.4066 15.054 22.298 15.1221 21.1613V18.4169C15.1001 17.7658 15.2093 17.1169 15.4432 16.5089C15.6772 15.9009 16.0311 15.3462 16.4839 14.8778C16.9367 14.4094 17.4791 14.037 18.0789 13.7826C18.6786 13.5282 19.3234 13.3971 19.9749 13.3971C20.6264 13.3971 21.2712 13.5282 21.8709 13.7826C22.4706 14.037 23.0131 14.4094 23.4659 14.8778C23.9187 15.3462 24.2726 15.9009 24.5065 16.5089C24.7405 17.1169 24.8497 17.7658 24.8277 18.4169V21.1613C24.8958 22.298 25.2084 23.4066 25.7443 24.4113C26.1279 25.0191 26.583 25.5787 27.0999 26.078H12.8499Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 29.044C20.3501 29.0359 20.6859 28.9044 20.9482 28.6726C21.2105 28.4408 21.3824 28.1237 21.4335 27.7773H18.5112C18.5637 28.1331 18.7436 28.4576 19.0175 28.6906C19.2914 28.9236 19.6406 29.0492 20.0001 29.044Z",
    fill: "#545454"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 9.5,
    r: 2.5,
    fill: "#E12828"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3204_18300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.74af93d442033b1fc79c19cd2e7e58e1.svg";
export { ForwardRef as ReactComponent };